import { DraftItem, DraftItemForm } from "src/app/models/models";

/**
 * Payload passed into `upsertDraft`.
 * Only the caller delta is returned. A draft read before the write queue must not
 * be merged in: `buildDraftUpsertRecord` spreads `delta` after the fresh IndexedDB row,
 * so a pre-queue snapshot would replace observations saved in between.
 */
export function draftSavePayload(
	delta: Partial<DraftItem> | Partial<DraftItemForm>,
): Partial<DraftItem> {
	return { ...((delta ?? {}) as Partial<DraftItem>) };
}

/**
 * In-queue upsert record. `existing` is the IndexedDB row read inside the write queue.
 * `delta` is applied on top of that row.
 */
export function buildDraftUpsertRecord(params: {
	id: string;
	existing?: DraftItem;
	delta: Partial<DraftItem>;
	continuePage: number;
	formDetails?: DraftItem["formDetails"];
	lastUpdatedDate: string;
}): DraftItem {
	const { id, existing, delta, continuePage, formDetails, lastUpdatedDate } = params;
	return {
		id,
		...(formDetails ? { formDetails } : {}),
		...(existing ?? {}),
		...delta,
		continuePage,
		lastUpdatedDate,
	} as DraftItem;
}
